// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3crhV","content":"LoadingAlert_content__ktDuP"};